import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2acc3e40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-map-picker" }
const _hoisted_2 = {
  key: 0,
  class: "ant-map-picker__coords"
}
const _hoisted_3 = {
  key: 2,
  class: "ant-map-picker__empty"
}

import { computed, reactive, ref, watch } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";
import { GOOGLE_MAP_API } from "@/config/app";
import type { MapLocation } from "./types";

export type { MapLocation };

interface Props {
  modelValue?: MapLocation | null;
  lat?: number;
  lng?: number;
  zoom?: number;
  height?: string;
  draggable?: boolean;
  showCoords?: boolean;
  apiKey?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapPicker',
  props: {
    modelValue: { default: null },
    lat: { default: 21.028511 },
    lng: { default: 105.804817 },
    zoom: { default: 15 },
    height: { default: "360px" },
    draggable: { type: Boolean, default: true },
    showCoords: { type: Boolean, default: true },
    apiKey: { default: GOOGLE_MAP_API }
  },
  emits: ["update:modelValue", "update:lat", "update:lng", "change", "pick"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const zoom = ref(props.zoom);
const center = reactive({
  lat: props.modelValue?.lat ?? props.lat,
  lng: props.modelValue?.lng ?? props.lng,
});
const marker = reactive({
  lat: props.modelValue?.lat ?? props.lat,
  lng: props.modelValue?.lng ?? props.lng,
});

const innerLat = computed(() => marker.lat);
const innerLng = computed(() => marker.lng);

const markerOptions = computed(() => ({
  position: {
    lat: marker.lat,
    lng: marker.lng,
  },
}));

const syncFromProps = () => {
  const nextLat = props.modelValue?.lat ?? props.lat;
  const nextLng = props.modelValue?.lng ?? props.lng;
  center.lat = nextLat;
  center.lng = nextLng;
  marker.lat = nextLat;
  marker.lng = nextLng;
  if (props.modelValue?.zoom != null) {
    zoom.value = props.modelValue.zoom;
  }
};

watch(
  () => [props.modelValue, props.lat, props.lng, props.zoom] as const,
  () => syncFromProps(),
  { deep: true }
);

const emitLocation = (lat: number, lng: number) => {
  const payload: MapLocation = { lat, lng, zoom: zoom.value };
  emit("update:modelValue", payload);
  emit("update:lat", lat);
  emit("update:lng", lng);
  emit("change", payload);
  emit("pick", payload);
};

const onClickMap = (event: any) => {
  const lat = event?.latLng?.lat?.() ?? event?.latLng?.lat;
  const lng = event?.latLng?.lng?.() ?? event?.latLng?.lng;
  if (typeof lat !== "number" || typeof lng !== "number") return;

  center.lat = lat;
  center.lng = lng;
  marker.lat = lat;
  marker.lng = lng;
  emitLocation(lat, lng);
};

const onDragEnd = (event: any) => {
  const lat = event?.latLng?.lat?.() ?? event?.latLng?.lat;
  const lng = event?.latLng?.lng?.() ?? event?.latLng?.lng;
  if (typeof lat !== "number" || typeof lng !== "number") return;

  marker.lat = lat;
  marker.lng = lng;
  center.lat = lat;
  center.lng = lng;
  emitLocation(lat, lng);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showCoords)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, "Lat: " + _toDisplayString(innerLat.value.toFixed(6)), 1),
          _createElementVNode("span", null, "Lng: " + _toDisplayString(innerLng.value.toFixed(6)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.apiKey)
      ? (_openBlock(), _createBlock(_unref(GoogleMap), {
          key: 1,
          "api-key": _ctx.apiKey,
          class: "ant-map-picker__map",
          style: _normalizeStyle({ width: '100%', height: _ctx.height }),
          center: center,
          zoom: zoom.value,
          onClick: onClickMap
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Marker), {
              options: markerOptions.value,
              clickable: true,
              draggable: _ctx.draggable,
              onDragend: onDragEnd
            }, null, 8, ["options", "draggable"])
          ]),
          _: 1
        }, 8, ["api-key", "style", "center", "zoom"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " Thiếu Google Maps API key "))
  ]))
}
}

})